/**
 * Forma canônica do e-mail para gravação: sem espaços nas pontas e em
 * minúsculas — espelha o `normalizeEmail` do backend
 * (`shared/utils/email.utils.ts`). Cognito e DataTable guardam o e-mail como
 * recebido, então `Fulano@X.com` e `fulano@x.com` viram valores distintos.
 */
export function normalizeEmail(email: string | undefined | null): string {
  return (email ?? '').trim().toLowerCase();
}
